import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import FestivalPrediction from "@/pages/FestivalPrediction";
import MyPredictions from "@/pages/MyPredictions";
import Leaderboard from "@/pages/Leaderboard";
import Announcements from "@/pages/Announcements";
import Admin from "@/pages/Admin";
import Leagues from "@/pages/Leagues";
import LeagueDetail from "@/pages/LeagueDetail";
import JoinLeague from "@/pages/JoinLeague";
import Profile from "@/pages/Profile";
import Users from "@/pages/Users";
import UserProfile from "@/pages/UserProfile";
import Statistics from "@/pages/Statistics";
import Rules from "@/pages/Rules";
import Nav from "@/components/Nav";
import { useAuth } from "@/lib/auth.jsx";
import "@/App.css";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Indlæser…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/hjem" replace />;
  return children;
}

function AppShell({ children }) {
  return (
    <div className="min-h-screen">
      <Nav />
      <main className="pt-24 pb-20">{children}</main>
    </div>
  );
}

function AppShellPublic({ children }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen">
      {user && <Nav />}
      <main className={user ? "pt-24 pb-20" : "pt-10 pb-20"}>{children}</main>
    </div>
  );
}

export default function App() {
  const location = useLocation();
  // Detect session_id in URL fragment synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/hjem" element={<Protected><AppShell><Home /></AppShell></Protected>} />
      <Route path="/forudsigelser" element={<Protected><AppShell><MyPredictions /></AppShell></Protected>} />
      <Route path="/festival/:id" element={<Protected><AppShell><FestivalPrediction /></AppShell></Protected>} />
      <Route path="/leaderboard" element={<Protected><AppShell><Leaderboard /></AppShell></Protected>} />
      <Route path="/leaderboard/:festivalId" element={<Protected><AppShell><Leaderboard /></AppShell></Protected>} />
      <Route path="/nyheder" element={<Protected><AppShell><Announcements /></AppShell></Protected>} />
      <Route path="/leagues" element={<Protected><AppShell><Leagues /></AppShell></Protected>} />
      <Route path="/leagues/:id" element={<Protected><AppShell><LeagueDetail /></AppShell></Protected>} />
      <Route path="/join/:code" element={<JoinLeague />} />
      <Route path="/profil" element={<Protected><AppShell><Profile /></AppShell></Protected>} />
      <Route path="/brugere" element={<Protected><AppShell><Users /></AppShell></Protected>} />
      <Route path="/u/:userId" element={<Protected><AppShell><UserProfile /></AppShell></Protected>} />
      <Route path="/statistik" element={<Protected><AppShell><Statistics /></AppShell></Protected>} />
      <Route path="/regler" element={<AppShellPublic><Rules /></AppShellPublic>} />
      <Route path="/admin" element={<Protected adminOnly><AppShell><Admin /></AppShell></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
